// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'

// todo
// cssVars()

Vue.use(BootstrapVue)
Vue.use(Vuex)
/* Store */
const store = new Vuex.Store({
  state: {
    baseUrl: process.env.VUE_APP_apiURL,
    client_id: process.env.VUE_APP_client_id,
    client_secret: process.env.VUE_APP_client_secret,
    isAdmin:true,
    guards:['api','web','guest']
  },
  mutations: {
    setAdmin () {
      // mutate state
      state.isAdmin=true;
    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  data: {},
  methods:{
	logOut(){
		localStorage.removeItem('token');
		router.push({'name':'Login'})
	}
  },
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
})
